import { literal, struct } from 'io-ts/Decoder';

export const KeepAlive = struct({
	type: literal('keep-alive'),
});
